// Fenster-Ereignis „Seitenmenü öffnen". Seiten mit eigenem Handy-Kopf (z. B.
// der Suchkopf, components/mobile/HandySuchkopf.jsx) blenden den globalen Kopf
// aus, brauchen aber dasselbe Menü — eine Quelle (Navbar.jsx), kein Duplikat.
// Eigene Datei, damit die Navbar dafür nicht den ganzen Suchkopf lädt.
export const MENUE_EREIGNIS = "avliana:menue-oeffnen";
